var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollaborateicon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.351,
    height: 102.75,
    viewBox: "0 0 81.351 102.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield_1_",
    "data-name": "shield(1)",
    transform: "translate(-53.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2709",
    "data-name": "Group 2709",
    transform: "translate(53.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2708",
    "data-name": "Group 2708",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4431",
    "data-name": "Path 4431",
    d: "M134.526,6.328a2.253,2.253,0,0,0-3.562-.7A23.513,23.513,0,0,1,115.4,11.5,23.486,23.486,0,0,1,95.781.959a2.14,2.14,0,0,0-3.566,0A23.524,23.524,0,0,1,72.581,11.491,23.486,23.486,0,0,1,56.886,5.5,2.142,2.142,0,0,0,53.315,7.09V53.511c0,26.732,38.017,48.074,39.636,48.969a2.126,2.126,0,0,0,1.036.27,2.215,2.215,0,0,0,1.036-.261c1.618-.895,39.636-22.241,39.636-48.969V7.282A2.211,2.211,0,0,0,134.526,6.328Zm-4.149,47.188c0,21.907-30.35,41.032-36.391,44.619C87.942,94.547,57.6,75.444,57.6,53.516V11.4a27.8,27.8,0,0,0,14.984,4.376A27.761,27.761,0,0,0,93.987,5.724,27.777,27.777,0,0,0,115.4,15.777a27.8,27.8,0,0,0,14.976-4.371v42.11Z",
    transform: "translate(-53.315)",
    fill: "#ed1c24"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2711",
    "data-name": "Group 2711",
    transform: "translate(79.014 38.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2710",
    "data-name": "Group 2710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4432",
    "data-name": "Path 4432",
    d: "M210.715,192.642a2.142,2.142,0,0,0-3.027,0l-15.622,15.609-7.038-7.047A2.14,2.14,0,0,0,182,204.231l8.545,8.563a2.145,2.145,0,0,0,3.027,0l17.142-17.125A2.142,2.142,0,0,0,210.715,192.642Z",
    transform: "translate(-181.374 -192.016)",
    fill: "#ed1c24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborateicon2);
export default __webpack_public_path__ + "static/media/collaborateicon2.4f76c75c0477f944c13f8a32a57a7910.svg";
export { ForwardRef as ReactComponent };